import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_DIET_IMAGE_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateDietImageDetailsArgs } from '../graphql/transformers'
import { UPDATE_DIET_IMAGE_DETAILS } from '../redux/action-types'

const useUpdateDietImageDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isImageDetailsLoading, imageDetailsError } = useSelector(
    store => store.diets.diet,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_DIET_IMAGE_DETAILS_MUTATION,
        { id, data: transformToUpdateDietImageDetailsArgs(data) },
        dispatch,
        UPDATE_DIET_IMAGE_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    { isLoading: isImageDetailsLoading, error: imageDetailsError },
  ]
}

export default useUpdateDietImageDetailsMutation
